import { Card } from "../../../card";
import { Check, X, Minus } from "lucide-react";

interface ComparisonTableProps {
  data: {
    title?: string;
    features: string[];
    columns: Array<{
      name: string;
      isHighlighted?: boolean;
      values: Array<boolean | string | null>;
    }>;
  };
}

export const ComparisonTable = ({ data }: ComparisonTableProps) => {
  if (!data?.features || !data?.columns || !Array.isArray(data.features) || !Array.isArray(data.columns)) return null;

  return (
    <Card className="my-8 overflow-hidden bg-white border border-neutral-200 shadow-sm rounded-xl">
      {data.title && (
        <div className="px-6 py-4 border-b border-neutral-200">
          <h3 className="font-semibold text-lg text-neutral-900">{data.title}</h3>
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead>
            <tr>
              <th className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 w-1/3"></th>
              {data.columns.map((col, idx) => (
                <th
                  key={idx}
                  className={`px-6 py-4 border-b font-semibold text-center relative ${
                    col.isHighlighted
                      ? 'bg-gradient-to-b from-orange-50 to-orange-50/50 text-orange-700 border-orange-200'
                      : 'bg-neutral-50 text-neutral-900 border-neutral-200'
                  }`}
                >
                  {col.isHighlighted && (
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-400 via-orange-500 to-orange-400" />
                  )}
                  {col.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-200">
            {data.features.map((feature, featureIdx) => (
              <tr key={featureIdx} className="hover:bg-neutral-50/50 transition-colors">
                <td className="px-6 py-4 font-medium text-neutral-900 bg-neutral-50/30 border-r border-neutral-100">
                  {feature}
                </td>
                {data.columns.map((col, colIdx) => {
                  const value = col.values[featureIdx];
                  return (
                    <td
                      key={colIdx}
                      className={`px-6 py-4 text-center ${
                        col.isHighlighted ? 'bg-orange-50/30' : ''
                      }`}
                    >
                      {value === true ? (
                        <Check className={`w-5 h-5 mx-auto ${col.isHighlighted ? 'text-orange-500' : 'text-emerald-500'}`} />
                      ) : value === false ? (
                        <X className="w-5 h-5 text-rose-500 mx-auto" />
                      ) : value === null || value === undefined ? (
                        <Minus className="w-5 h-5 text-neutral-300 mx-auto" />
                      ) : (
                        <span className={`font-medium ${col.isHighlighted ? 'text-orange-700' : 'text-neutral-600'}`}>{value}</span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};




